import { render, staticRenderFns } from "./page-navigate.vue?vue&type=template&id=67963113&scoped=true&"
import script from "./page-navigate.vue?vue&type=script&lang=js&"
export * from "./page-navigate.vue?vue&type=script&lang=js&"
import style0 from "./page-navigate.vue?vue&type=style&index=0&id=67963113&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67963113",
  null
  
)

export default component.exports